module.exports = __webpack_public_path__ + "media/images/rename-iphone-frame-0657f51d29b24e9df3e3a97eb25ddcdc.png";